module.exports = __webpack_public_path__ + "static/media/integration.57c7837d.svg";